import React, { useState, useEffect } from "react";
import "../style/sign.css";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { postWithoutTokenAPI, getWithTokenAPI } from '../util/Api';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { login, loginSuccess } from '../store/auth/action';
import { setWishlist } from '../store/wishlistSlice';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from 'react-redux';
import { setTotalItems } from '../store/cartSlice';

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const mylogin = useSelector((state) => state.auth?.auth?.access_token);
  const navigate = useNavigate();
  const dispatch = useDispatch();
    const userId = useSelector((state) => state.auth?.auth?._id);


  const togglePasswordVisibility = () => {
    setShowPassword(prev => !prev);
  };

  const fetchUserWishlist = async (token, userId) => {
    try {
      const response = await getWithTokenAPI(token, `/wishlist/find-all?user_id=${userId}`);
      if (response?.statusCode === 200) {
        const wishlistData = response.data?.wishlist || [];
        // Ensure each item has the correct structure
        const formattedWishlist = wishlistData.map(item => ({
          ...item,
          product_id: item.product_id || item._id,
          _id: item._id
        }));
        dispatch(setWishlist(formattedWishlist));
      } else {
        console.warn("Failed to fetch wishlist:", response);
      }
    } catch (error) {
      console.error('Error fetching wishlist:', error);
    }
  };
  useEffect(() => {
    const fetchCartCount = async (token, userId) => {
      if (!userId) return;
      try {
        const response = await getWithTokenAPI(token, `/cart/find-all?user_id=${userId}`);
        if (response?.statusCode === 200 && response.data) {
          dispatch(setTotalItems(response.data.total_count));
        }
      } catch (error) {
        console.error('Error fetching cart count:', error);
      }
    };

    fetchCartCount();
  }, [userId, dispatch]);
  useEffect(() => {
    if (mylogin) {
      navigate('/user'); // or any page you want
    }
  }, [mylogin, navigate]);
  const handleLogin = async () => {
    setError(null);

    if (!email || !password) {
      setError("Please enter both email and password");
      return;
    }

    try {
      const response = await postWithoutTokenAPI("/user/login", {
        email,
        password,
        role: "user"
      });

      if (response.statusCode === 200 && response.data?.access_token) {
        dispatch(loginSuccess(response.data, response.data.access_token));

        // Fetch and set wishlist items with user ID
        await fetchUserWishlist(response.data.access_token, response.data._id);

        // Show success toast
        toast.success("Login successful!", {
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          onClose: () => navigate("/")
        });
      } else {
        setError(response.message || "Login failed");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Something went wrong. Please try again");
    }
  };

  return (
    <>
      {!mylogin &&
        <div className="login-box">
          <ToastContainer
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />

          <h2 className="login-title">Sign In</h2>

          <div className="login-field">
            <input
              className="login-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
            />
          </div>

          <div className="login-field">
            <div className="password-wrapper-sign">
              <input
                className="login-input"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
              />
              <span className="eye-icon-sign" onClick={togglePasswordVisibility}>
                {showPassword ? <FiEye /> : <FiEyeOff />}
              </span>
            </div>
          </div>

          <div className="login-links">
            <div className="remember-section">
              <input type="checkbox" id="remember" />
              <label htmlFor="remember" className="remember-label">Remember me</label>
            </div>
            <Link to="/Forgotphonenumber" state={{ fromForgotPassword: true }} className="forgot-link">Forgot Password</Link>
          </div>

          <button className="login-button" onClick={handleLogin}>Login</button>

          {error && <p className="error-message">{error}</p>}

          <div className="signup-link">
            <span>Don't have account?</span>
            <a href="/creates">Register</a>
          </div>
        </div>
      }

    </>

  );
};

export default Login;